'use strict';

import "../../node_modules/tiny-slider/src/tiny-slider.scss";
import {tns} from "../../node_modules/tiny-slider/src/tiny-slider";


import "../lib/jquery.waterwheelCarousel.min.js"
import 'bootstrap/js/src/modal';

import BackgroundImageRotation from "../shared/backgroundImageRotation"

import InfoPopup from "../shared/InfoPopup"

class BlockSlideShow {

	constructor($target) {

		//Private properties
    $target;
    let backgroundImageModalRotations = [];
    let animWideScreen = window.matchMedia("(min-width:992px)");
    var carousel = $target.find("#carousel");
    var sliderModal = $target.find('.slide_modal__image');
    var sliderImgs = $target.find('.block_slideshow__carousel img');
    // var azBtn = $target.find('.block_slideshow__header_link');
    var linkTo = $target.find('#scrollHere');
    let infoPopup
 
    
    function init(){
      initModal();
      switchCarousel();
      $(window).resize(switchCarousel);
      checkForDeepLink();
      deepLinkEventHandler()
      // scrollToList();
    }
    
    // function scrollToList(){
    //   azBtn.click(function(e) {
    //     e.preventDefault();

    //     $('html,body').animate({scrollTop: $(linkTo).offset().top},'slow');
    //   });
    // }
    
    function deepLinkEventHandler(){

      window.addEventListener('popstate', (event) => {

        $(".modal").modal('hide')

        if(window.hash != undefined){

          checkForDeepLink();

        }

      });

    }

    function checkForDeepLink(){
      sliderImgs.each((index, image) => {

        if(window.location.hash == $(image).data("modal-hash")){
          setTimeout(function(){
            if(image.className != 'carousel-center'){
              //Lets ensure the carousel image is at the center
              $(image).trigger("click")
            }
            showModal($(image))
          }, 500)

        }

      })
    }

    function initModal(){

      infoPopup = new InfoPopup($(".modal"))

      $('body').on('click', '.block_slideshow__slide_btn', function (event) {
        event.preventDefault();
  
        let dataID = $(this).data('target');
  
          $(".modal").each((index, value) => {
            let modalID = value.getAttribute("id");
            if (modalID == dataID) {
            
              infoPopup.showModal(index);
              
            }
          });

          
      });

    }

    function showModal($ImageTarget){
      let dataMobID = $ImageTarget.data('target');
      $(".modal").each((index, value) => {
        let modalID = value.getAttribute("id");
        let bgImages = $(value).find('.slide_modal__images_wrap').find('img');

        if (modalID == dataMobID) {
          history.pushState("state", "", $ImageTarget.data("modal-hash"))
          infoPopup.showModal(index);
        }
      });
    }

    function switchCarousel(){
      if(animWideScreen.matches){
        
        carousel.waterwheelCarousel({});
   
        sliderImgs.each((ind, imageElement) => {

          $(imageElement).on('click', function(event){

            if(imageElement.className === 'carousel-center'){
                event.preventDefault();
                showModal($(this))
            }
            
          })
 
        });


        $('#prev').bind('click', function () {
          carousel.prev();
          return false
        });
    
        $('#next').bind('click', function () {
          carousel.next();
          return false;
        });

      }else{

        $('#carousel img').each((index, value) => {
          $(value).css({
            "width": "100%",
            "height": "250px",
            "max-height" : "250px",
            "max-width" : "490px",
            "object-fit":"cover"
           
          });

          clickOnImage();


      
        });

      }
    }

    
    function clickOnImage(){
      $('body').on('click', '#carousel img', function (event) {
          
        event.preventDefault();
        showModal($(this))

      });
    }

    init();

          return {


			publicBlockSlideShow:function(string){

			

			}

		}

	}

}

export default BlockSlideShow;